<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Produtos</v-subheader>
        <v-divider/>
        <v-list>
          <div class="text-center">
            <px-circular-loaging v-if="loadingCampoHidden"/>
          </div>
          <template v-for="(produto, index) in requisicao.produtos">
            <v-list-item  v-if="!loadingCampoHidden"
                         :key="produto.id">
              <v-list-item-content>
                <v-list-item-title>
                  <px-situacao-requisicao-icon :situacao="produto.situacao"/>
                  <px-produto-descricao v-if="produto.produto"
                                        :especificacao="produto.especificacaoProduto"
                                        :produto="produto.produto"/>&nbsp;
                  <span v-if="!produto.produto">
                  {{ produto.especificacaoProduto }}
                </span>
                  <px-show-fornecedores-homologados-produto v-if="produto.produto"
                                                            small
                                                            :produto="produto.produto"/>
                  <px-resumo-produto-dialog v-if="produto.produto"
                                            :produto="produto.produto"
                                            :unidade-medida="produto.unidadeMedida"/>
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  {{
                    produto.quantidade
                      | number(getCurrencyFormat(casasDecimaisItem(produto)))
                  }}
                  {{ produto.unidadeMedida.descricao }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div class="d-flex">
                  <px-anexo read-only
                            v-model="produto.arquivos"
                            download-base-path="files/download-comprador"/>
                  <px-previsao-entrega-requisicao-produto text-class="small-text"
                                                          :id-item-requisicao="produto.id"/>
                  <px-detalhes-produto
                    :produto="produto"
                    show-projeto
                    show-obs-externa
                    show-obs-interna
                    show-finalidade-compra
                    show-data-previsao-entrega
                    show-centro-custo
                    :show-motivo-recusa="isCancelada(produto)">
                    <template v-slot:bottom>
                      <px-campos-integracao
                        v-if="cadastrosAdicionaisItem(produto)
                              && showCadastrosAdicionaisItem(produto)
                              && erpCamposIntegracao"
                        full-width
                        type="requisicao-produtos-view"
                        text-class="small-text"
                        :form-data="cadastrosAdicionaisItem(produto)"/>
                    </template>
                  </px-detalhes-produto>
                  <px-preco-target v-if="checkPrecoTarget(produto)" :produto="produto"/>
                  <v-menu :close-on-content-click="false" v-if="hasRoleCompradorOuRequisicao">
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <px-cancelar-dialog
                        texto-botao="Cancelar produto"
                        :titulo="getTitulo"
                        :descricao="getDescricao(produto)"
                        @cancelar-dialog="motivoRecusa => onClickCancelar(motivoRecusa, produto)"
                        :disabled="isFinalizada(produto)"/>
                      <v-list-item v-if="hasRoleComprador" :disabled="isFinalizada(produto)"
                          @click="onClickFinalizar(produto)">
                        <v-list-item-icon>
                          <v-icon>mdi-check</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>Finalizar produto</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index !== (requisicao.produtos.length - 1)"
                       :key="`v-div${produto.id}`"/>
          </template>
        </v-list>
      </v-card>
    </v-col>
    <px-confirm-dialog ref="confirmCancelar"/>
    <px-confirm-dialog ref="confirmFinalizar"/>
  </v-row>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import { SituacaoRequisicao, ErpCamposIntegracao, TipoProduto } from 'px-business-components';
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingCampoHidden: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    hasRoleCompradorOuRequisicao() {
      return this.hasRoleComprador || this.hasRoleRequisicao;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    isFinalizada() {
      return produto => [SituacaoRequisicao.keys.FINALIZADA.key,
        SituacaoRequisicao.keys.CANCELADA.key].includes(produto.situacao);
    },
    isCancelada() {
      return produto => SituacaoRequisicao.keys.CANCELADA.key === produto.situacao;
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    showCadastrosAdicionaisItem() {
      return (item) => {
        if (this.erpCamposIntegracao === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
          return item?.produto.tipoProduto === TipoProduto.keys.PRODUTO.key;
        }
        return this.erpCamposIntegracao !== null;
      };
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
    checkPrecoTarget() {
      return item => (item.produto
        ? item.produto.precoTarget && item.produto.precoTarget > 0 : false);
    },
    dataPrevisaoEntrega() {
      return produto => produto.dataPrevisaoEntregaItemCompra;
    },
    getTitulo() {
      return 'Cancelar solicitação';
    },
    getDescricao() {
      return item => `O produto "${this.descricaoItem(item)}" será cancelado e a operação não poderá ser desfeita.`;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    onClickCancelar(motivoRecusa, produto) {
      RequisicoesService.cancelarProduto(produto.id, { motivoRecusa })
        .then(() => {
          this.$toast('Produto cancelado', { color: 'success' });
          this.emitUpdate();
        });
    },
    finalizar(produto) {
      RequisicoesService.finalizarProduto(produto.id)
        .then(() => {
          this.$toast('Produto cancelado', { color: 'success' });
          this.emitUpdate();
        });
    },
    onClickFinalizar(produto) {
      this.$refs.confirmFinalizar.open('Você deseja finalizar este produto?',
        'Esta operação não pode ser desfeita',
        { width: 350 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.finalizar(produto);
        });
    },
    descricaoItem(produto) {
      if (!produto.produto) {
        return produto.especificacaoProduto;
      }
      const codigo = produto.produto.codigo ? `${produto.produto.codigo} - ` : '';
      if (produto.produto.isGenerico && produto.especificacaoProduto) {
        return codigo + produto.especificacaoProduto;
      }
      return codigo + produto.produto.descricao;
    },
  },
};
</script>
